<template>
  <sc-page-base title="Configurações de Auditoria de faturas">
    <div class="columns">
      <div class="column">
        <configuration-invoice-markers />
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <configuration-invoice-margins />
      </div>
    </div>
  </sc-page-base>
</template>

<script>
  import {
    ScPageBase,
    ScField,
  } from '@intelipost-js/secure-components';
  import ConfigurationInvoiceMarkers from './blocks/ConfigurationInvoiceMarkers';
  import ConfigurationInvoiceMargins from './blocks/ConfigurationInvoiceMargins';

  export default {
    name: 'page-configuration-invoice',
    components: {
      ScPageBase,
      ScField,
      ConfigurationInvoiceMarkers,
      ConfigurationInvoiceMargins,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/configuration-invoice/PageConfigurationInvoice.vue